module.exports = __webpack_public_path__ + "static/media/img_mobile_overseas_02.e43153b3.png";